import React, { useState, useEffect } from "react";
import * as S from "./DepositInfoModalStyle";
import { useMessage } from "../../../context/MessageContext"; // Importe seu hook de mensagem
import { FiX } from "react-icons/fi"; // Ícone para fechar
import { companyReceivingAccountService as accountService } from "../../../Services/companyReceivingAccountService";

const DepositInfoModal = ({ onClose }) => {
  const { showMessage } = useMessage();

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchAccounts = async () => {
      try {
        const data = await accountService.getActiveAccounts();
        if (isMounted) {
          setAccounts(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error("Erro ao carregar contas para depósito:", err);
        if (isMounted) setError(true);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAccounts();

    return () => {
      isMounted = false;
    };
  }, []);

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        showMessage("Chave PIX copiada!", "success");
      })
      .catch((err) => {
        console.error("Erro ao copiar: ", err);
        showMessage("Falha ao copiar a chave PIX.", "error");
      });
  };

  const pixTypeLabel = (type) =>
    type ? accountService.PixKeyTypeLabels[type] || type : "";

  const renderContent = () => {
    if (loading) {
      return (
        <S.StateWrapper>
          <S.Spinner />
          <S.StateMessage>Carregando contas...</S.StateMessage>
        </S.StateWrapper>
      );
    }

    if (error) {
      return (
        <S.StateWrapper>
          <S.StateMessage>
            Não foi possível carregar as contas. Tente novamente mais tarde.
          </S.StateMessage>
        </S.StateWrapper>
      );
    }

    if (accounts.length === 0) {
      return (
        <S.StateWrapper>
          <S.StateMessage>Nenhuma conta disponível no momento.</S.StateMessage>
        </S.StateWrapper>
      );
    }

    return (
      <S.BoxesContainer>
        {accounts.map((item) => (
          <S.Box key={item.id}>
            <S.BoxContent>
              <S.BankTitle>{item.bank}</S.BankTitle>

              <S.InfoSection>
                <S.InfoLabel>Beneficiário</S.InfoLabel>
                <S.InfoValue>{item.beneficiary}</S.InfoValue>
                <S.InfoValue>{item.beneficiaryCnpj}</S.InfoValue>
              </S.InfoSection>

              <S.InfoSection>
                <S.InfoLabel>Agência / Conta</S.InfoLabel>
                <S.InfoValue>
                  {(item.agency || "-")} / {(item.accountNumber || "-")}
                </S.InfoValue>
              </S.InfoSection>

              {item.pixKey && (
                <S.InfoSection>
                  <S.InfoLabel>
                    PIX{item.pixKeyType ? ` (${pixTypeLabel(item.pixKeyType)})` : ""}
                  </S.InfoLabel>
                  <S.PixInfo>{item.pixKey}</S.PixInfo>
                </S.InfoSection>
              )}
            </S.BoxContent>
            <S.CopyButton
              onClick={() => copyToClipboard(item.pixKey)}
              disabled={!item.pixKey}
            >
              Copiar Chave PIX
            </S.CopyButton>
          </S.Box>
        ))}
      </S.BoxesContainer>
    );
  };

  return (
    <S.ModalContainer>
      <S.ModalBox>
        <S.CloseButton onClick={onClose} title="Fechar">
          <FiX />
        </S.CloseButton>
        <S.ScrollableContent>
          <S.HeaderContent>
            <S.Title>Contas Para Depósito</S.Title>
            <S.SubTitle>Golden Brasil</S.SubTitle>
          </S.HeaderContent>

          {renderContent()}
        </S.ScrollableContent>
      </S.ModalBox>
    </S.ModalContainer>
  );
};

export default DepositInfoModal;
